import React from "react";
import { Box, Typography, MenuItem, Select } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const VARIANT_STYLE = {
  enabled: {
    backgroundColor: 'transparent',
    color: '#601350',
    border: 'none',
    boxShadow: 'none',
    cursor: 'pointer',
  },
  hovered: {
    backgroundColor: '#60135014',
    color: '#601350',
    border: 'none', 
    cursor: 'pointer',

  },
  focused: {
    backgroundColor: 'rgba(96, 19, 80, 0.16)',
    color: '#601350',
    border: 'none',
    borderRadius:"6px", 
    cursor: 'pointer',
  
  },
  disabled: {
    backgroundColor: '#f8f3fa',
    color: '#bdbdbd',
    border: 'none',
    boxShadow: 'none',
    cursor: 'not-allowed',
  },
};


const FilterDropdown = ({
  variant = "enabled",
  label = "Label",
  value = "all",
  onChange,
  ...props
}) => {
  const style = VARIANT_STYLE[variant] || VARIANT_STYLE.enabled;
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
      <Typography variant="body2" sx={{ color: style.color, fontWeight: 500, fontSize: 14}}>
        {label}:
      </Typography>
      <Select
        value={value}
        onChange={onChange}
        IconComponent={KeyboardArrowDownIcon}
        disabled={variant === 'disabled'}
        sx={{
          minWidth: 80,
          height: 32,
          fontSize: 14,
          borderRadius: 2,
          pl: 1,
          py: 2,
          border: 'none',
          outline: 'none',
          boxShadow: style.boxShadow,
          backgroundColor: style.backgroundColor,
          color: style.color,
          cursor: style.cursor,
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '& .MuiSelect-icon': {
            color: style.color,
          },
        }}
        MenuProps={{
          PaperProps: {
            sx: { mt: 0.5, borderRadius: 2 },
          },
        }}
        {...props}
      >
        <MenuItem value="all">All</MenuItem>
        <MenuItem value="option1">Option 1</MenuItem>
        <MenuItem value="option2">Option 2</MenuItem>
      </Select>
    </Box>
  );
};

export default FilterDropdown;
